import { Config, MuiConfig } from '@react-awesome-query-builder/mui';
import { ageWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/AgeWidget';
import { callingStatusWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/CallingStatusWidget';
import { engagementHistoryWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/EngagementHistoryWidget';
import { eventAttendanceWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/EventAttendanceWidget';
import {
  fetchAutocompleteWidget,
  fetchAutoCompleteWithOperatorWidget,
} from '@pages/AdvancedSearchListCreatorPage/customWidgets/FetchAutocompleteWidget';
import { idArrayWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/IdArrayWidget';
import { mailingWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/MailingWidget';
import { membershipWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/MembershipWidget';
import { rosterWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/RosterWidget';
import { selectWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/SelectWidget';
import { taskWidget } from '@pages/AdvancedSearchListCreatorPage/customWidgets/TaskWidget';

export const initialConfig = MuiConfig;

export function buildQueryBuilderTypes(config: Config = initialConfig) {
  return {
    ...config.types,
    fetch: {
      widgets: {
        fetchAutocomplete: {
          operators: ['any in'],
        },
      },
    },
    fetchLocation: {
      widgets: {
        fetchAutocomplete: {
          operators: ['lives in'],
        },
      },
    },
    operatorFetch: {
      widgets: {
        fetchAutocompleteWithOperator: {
          operators: ['lives in', 'lives or placement in', 'placement in'],
        },
      },
    },
    membership: {
      widgets: {
        membership: {
          operators: ['any in'],
        },
      },
    },
    mailing: {
      widgets: {
        mailing: {
          operators: ['any in'],
        },
      },
    },
    task: {
      widgets: {
        task: {
          operators: ['any in'],
        },
      },
    },
    roster: {
      widgets: {
        roster: { operators: ['any in'] },
      },
    },
    eventAttendance: {
      widgets: {
        eventAttendance: { operators: ['any in'] },
      },
    },
    engagementHistory: {
      widgets: {
        engagementHistory: { operators: ['any in'] },
      },
    },
    callingStatus: {
      widgets: {
        callingStatus: { operators: ['any in'] },
      },
    },
    idArray: {
      widgets: {
        idArray: { operators: ['is one of'] },
      },
    },
    age: {
      widgets: {
        age: {
          operators: ['Equal to', 'Older than or equal to', 'Younger than or equal to'],
        },
      },
    },
  };
}

export function buildQueryBuilderWidgets(config: Config = initialConfig) {
  return {
    ...config.widgets,
    select: selectWidget,
    fetchAutocomplete: fetchAutocompleteWidget,
    fetchAutocompleteWithOperator: fetchAutoCompleteWithOperatorWidget,
    membership: membershipWidget,
    task: taskWidget,
    mailing: mailingWidget,
    roster: rosterWidget,
    eventAttendance: eventAttendanceWidget,
    engagementHistory: engagementHistoryWidget,
    callingStatus: callingStatusWidget,
    idArray: idArrayWidget,
    age: ageWidget,
  };
}

export function buildQueryBuilderOperators(config: Config = initialConfig) {
  return {
    ...config.operators,
    'lives in': { label: 'lives in' },
    'lives or placement in': { label: 'lives or placement in' },
    'placement in': { label: 'placement in' },
    'Equal to': { label: 'equal to' },
    'Older than or equal to': { label: 'older than or equal to' },
    'Younger than or equal to': { label: 'younger than or equal to' },
  };
}
